import { render, staticRenderFns } from "./LevelHistory.vue?vue&type=template&id=08f964ba"
import script from "./LevelHistory.vue?vue&type=script&lang=js"
export * from "./LevelHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports